
import {useNavigate} from 'react-router-dom';
import {Button} from 'antd';

import {INDEX} from '../../config/routes';

import cls from './Result.module.scss'


export const NoTry = () => {

    const navigate = useNavigate();

    return (

        <div className={cls.page}>

            <h1>Не осталось попыток</h1>

            <div>Не расстраивайся, дорогой друг, так бывает.<br/>
                В следующий раз удача будет на вашей стороне 🍀</div>

            <Button onClick={() => navigate(INDEX)}>На главную</Button>

        </div>

    )
}


